import React from "react";
import waves from "../images/waves.png";
const ProjectFooter = () => {
  return (
    <div className="project-footer">
      <img src={waves} alt="" />
      <p className="overline">Made with 🍵 and 💻 by G S Ashish</p>
    </div>
  );
};

export default ProjectFooter;
